import { useState, useEffect } from 'react';
import { emailTrackerService, EmailRecord } from '../../services/email/emailTrackerService';

export const useEmailTracker = () => {
  const [emails, setEmails] = useState<EmailRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [count, setCount] = useState(50);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);

  const fetchEmails = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await emailTrackerService.getEmails(count, offset);
      setEmails(response.emails);
      setTotal(response.total);
    } catch (err) {
      console.error('Error fetching emails:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch emails');
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    fetchEmails();
  };

  const loadMore = () => {
    setOffset(prev => prev + count);
  };

  const loadPrevious = () => {
    setOffset(prev => Math.max(0, prev - count));
  };

  const resetPagination = () => {
    setOffset(0);
  };

  const goToPage = (pageNumber: number) => {
    setOffset(pageNumber * count);
  };

  useEffect(() => {
    fetchEmails();
  }, [count, offset]);

  return {
    emails,
    loading,
    error,
    total,
    count,
    offset,
    setCount,
    refreshData,
    loadMore,
    loadPrevious,
    resetPagination,
    goToPage
  };
}; 